import { useMemo } from 'react';
import { useApolloClient, gql } from '@apollo/client';
import { ModificationGroupFragment } from './__queries__';

/**
 * Use this to extract the full data of the modificationGroups
 * @param {string[]} modificationGroupIds - Array of modification group IDs
 * @returns {ModificationGroupFragment[]} - Array of modification groups
 */
export const useGetModificationGroups = (
  modificationGroupIds: string[],
): ModificationGroupFragment[] => {
  const client = useApolloClient();

  const modificationGroups = useMemo(() => {
    return modificationGroupIds
      .map(
        (id) =>
          client.readFragment<ModificationGroupFragment>({
            id,
            fragment: gql`
              fragment ModificationGroupFragment on ModificationGroup {
                id
                internalName
                externalName
                type
                required
                expandedByDefault
                preselectedVariations
                isGridViewEnabled
                icon
                variations {
                  id
                  price
                  name
                  nameLang {
                    id
                    se
                    en
                    es
                    no
                  }

                  asItem {
                    id
                  }

                  image {
                    id
                    file {
                      id
                      url
                    }
                  }
                }
              }
            `,
          })!,
      )
      .filter(Boolean); // Item.modificationGroups array will not update when a modificationGroup is deleted. So we need to filter those out.
  }, [modificationGroupIds, client]);

  return modificationGroups;
};
